/** Load the PDF engine and its worker only when a document-capable route opens. */
let configured: Promise<void> | null = null

export function ensurePdfWorker(): Promise<void> {
  configured ??= Promise.all([
    import('@signbento/pdf'),
    import('./pdf-render-worker.ts?worker&url'),
  ])
    .then(([pdf, worker]) => {
      // The standard fonts are served beside the app (vite.config.ts, pdfStandardFonts).
      pdf.configurePdfWorker(worker.default, {
        standard_font_data_url: `${import.meta.env.BASE_URL}pdfjs/standard_fonts/`,
      })
    })
    .catch((error: unknown) => {
      configured = null
      throw error
    })
  return configured
}
